import { Schema, ZodIssue, ZodTypeDef } from 'zod/v3';
import { parseWarningMessage } from '../warningMessage';

// TODO: unit tests (see libs/sdk/src/classifier/schema/ClassifierSchema.spec.ts for example)
export const suppressWarnings = <FormData>(
  schema: Schema<FormData, ZodTypeDef, any>,
) =>
  schema.catch((ctx) => {
    if (ctx.error.issues.every(isWarning)) {
      return ctx.input as FormData;
    }
    throw ctx.error;
  });

const isWarning = (issue: ZodIssue) =>
  Boolean(parseWarningMessage(issue.message));
